import { useEffect, useContext, useState } from "react";
import { cerrarSession, returnMayus } from "../../utils/funciones";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataContext } from "../../contextData/contextData";
import { PUESTOS, EXISTE_MENU, EXISTE_CONFIRMALO } from "../../utils/Constants";
import { modalEjecutar } from "./sweetAlerts";
import { getUno } from "../../api/apis";
import { Link } from "react-router-dom";
import { faUserAltSlash, faUserClock, faUsers, faArrowsRotate, faArrowRightFromBracket, faTableList, faHourglassHalf, faPaperPlane, faArrowRotateLeft, faSignature, faList, faTv } from "@fortawesome/free-solid-svg-icons";
import { Icono } from "./Iconos";
import "../../css/sidebar.css";

const returnTo = () => (["7"].includes(localStorage.getItem("id_perfil")) ? "/" : "/firma-contrato");

const clsLink = "nav-link active py-2 w-100";

const ItemLista = ({ to, label, iconName }) => {
  return (
    <li className="nav-item rounded-3 ps-2 linkNavBar">
      <Link to={to} className={clsLink}>
        <div className="d-flex flex-row">
          <div style={{ width: "38px" }}>
            <FontAwesomeIcon fixedWidth={true} icon={iconName} />
          </div>
          {label}
        </div>
      </Link>
    </li>
  );
};

ItemLista.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconName: PropTypes.object.isRequired,
};

export const SideBar = ({ ejecutar }) => {
  const idPerfil = localStorage.getItem("id_perfil");
  const { notificaciones } = useContext(DataContext);
  const [version, setVersion] = useState(undefined);
  const [modulo, setModulo] = useState(undefined);
  const [puedeVerMonitor, setPuedeVerMonitor] = useState(false);

  useEffect(() => {
    async function obtenerVersion() {
      const resp = await getUno("version");
      setVersion(resp.data);
      setModulo(EXISTE_MENU === "1" ? localStorage.getItem("modulo") : "1");
    }

    async function fetchMonitorData() {
      const idUsuarioSAP = localStorage.getItem("id_usuario_sap");
      const resp = await getUno("usuarios_monitor", null, null);
      if (resp?.data?.data) {
        const puedeVer = resp.data.data.some(user => user.NPersonal === idUsuarioSAP);
        setPuedeVerMonitor(puedeVer);
      }
    }

    obtenerVersion();
    fetchMonitorData();
  }, []);

  return (
    <div className="offcanvas modalSideBar offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div className="offcanvas-header bgArcoprime">
        <a className="navbar-brand" href="/">
          <div className="logoBlanco"></div>
        </a>
        <button id="sideBarBtn" className="btn btn-primary btnSidebar" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" style={{ paddingRight: "12px", paddingLeft: "10px" }}>
          <Icono iconName="arrowLeft" />
        </button>
      </div>

      <div className="offcanvas-body">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          {modulo === "1" && (
            <>
              {(["3", "4"].includes(idPerfil) || !["6", "7"].includes(idPerfil)) && <div className="sub-header">Solicitudes</div>}
              {!["6", "7"].includes(idPerfil) && (
                <>
                  <ItemLista to="/" label="En progreso" iconName={faHourglassHalf} />
                  <ItemLista to="/listSolicitudReingreso" label="Reingreso" iconName={faArrowRotateLeft} />
                </>
              )}
              {["3"].includes(idPerfil) && <ItemLista to="/resumen-solicitudes" label="Resúmen" iconName={faTableList} />}
              {["4"].includes(idPerfil) && (
                <li className="nav-item rounded-3 ps-2 linkNavBar">
                  <Icono iconName="consulta" />
                  <Link to="/consulta-rut" className={clsLink}>
                    Iniciar contratación
                  </Link>
                </li>
              )}

              {!["2", "4"].includes(idPerfil) && <div className="sub-header">Procesos</div>}
              {["3"].includes(idPerfil) && (
                <>
                  <ItemLista to="/envio-sap" label="Enviar a SAP" iconName={faPaperPlane} />
                  <ItemLista to="/log-temporis" label="Log de temporis" iconName={faList} />
                </>
              )}
              {["1"].includes(localStorage.getItem("puedeverfirma")) && (
                //a esta seccion solo pueden ver perfil 7 O si tiene el token de tiene documentos o... es usuario monitor
                <ItemLista to={returnTo()} label="Documentos a revisar" iconName={faSignature} />
              )}

              {(["6", "7"].includes(idPerfil) || puedeVerMonitor) && (
                <>
                  {EXISTE_CONFIRMALO && <ItemLista to="/monitor-confirmalo" label="Monitor confirmalo" iconName={faTv} />}
                  <ItemLista to="/monitor-firma" label="Monitor webdox" iconName={faTv} />
                </>
              )}
            </>
          )}
          {modulo === "2" && (
            <>
              {["2", "3", "4", "6", "7"].includes(idPerfil) && <div className="sub-header">Solicitudes</div>}

              <ItemLista to="/solicitudes-en-curso" label="En Curso" iconName={faHourglassHalf} />

              {["4"].includes(localStorage.getItem("id_perfil")) && (
                <li className="nav-item rounded-3 ps-2 linkNavBar">
                  <Icono iconName="consulta" />
                  <Link to="/" className={clsLink}>
                    Iniciar solicitud
                  </Link>
                </li>
              )}
              <ItemLista to="/solicitudes-traspaso" label="De traspaso" iconName={faUsers} />
              <ItemLista to="/historial-solicitudes" label="Historial" iconName={faTableList} />

              {["3"].includes(localStorage.getItem("id_perfil")) && (
                <>
                  <div className="sub-header">Procesos</div>
                  <ItemLista to="/envio-a-sap" label="Enviar a SAP" iconName={faPaperPlane} />
                  <ItemLista to="/ajustes-de-dias" label="Ajustes de días" iconName={faUserClock} />
                </>
              )}
            </>
          )}
          {modulo === "3" && <ItemLista to="/desvinculacion-colaborador" label="Desvinculación colaborador" iconName={faUserAltSlash} />}
        </ul>
      </div>

      <div className="px-3 pb-3">
        <p className="h6 mb-1 d-flex justify-content-end linkNavBar">Versión: {version}</p>

        <ul id="itemBar2" className="navbar-nav mb-2 mb-lg-0 d-flex justify-content-end flex-row bgArcopime">
          <li className="d-flex flex-column justify-content-center px-2" style={{ whiteSpace: "nowrap", fontSize: "14px", overflowX: "hidden" }}>
            <label className="text-white text-end"> {returnMayus(localStorage.getItem("usuarioNombre"))} </label>
            <hr className="lineaPerfil" />
            <label className="text-white fw-bold text-end"> {(PUESTOS[localStorage.getItem("id_perfil")] || "NO AUTENTICADO").toUpperCase()} </label>
          </li>

          <li className="nav-item">
            <div className="dropdown text-end">
              <div className="p-2 d-block link-dark text-decoration-none dropdown-toggle btnCerrarSesion rounded-3" id="dropdownUser1" data-bs-toggle="dropdown">
                <img src={`https://${(localStorage.getItem("foto_perfil") || "").replace(/^https?:\/\//, "").replace(/^https?\/\//, "")}`} alt="mdo" width="40" height="40" className="rounded-circle" />

                {notificaciones.length > 0 && (
                  <span
                    className="badge bg-warning text-dark p-1 rounded-circle d-flex justify-content-center"
                    style={{
                      position: "absolute",
                      fontSize: "11px",
                      top: "30px",
                      right: "62px",
                      height: "20px",
                      width: "20px",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    <Icono iconName="notif" />
                  </span>
                )}
              </div>
              <ul className="dropdown-menu dropdown-menu-end text-small p-1" aria-labelledby="dropdownUser1">
                {notificaciones.length > 0 && (
                  <li key={0} className="dropdown-item fw-bold d-flex justify-content-between align-items-center px-2" style={{ cursor: "pointer" }}>
                    Notificaciones
                    <span
                      className="badge rounded-pill bg-warning text-dark d-flex justify-content-center align-items-center"
                      style={{
                        height: "20px",
                        width: "20px",
                        paddingBottom: "6px",
                      }}
                    >
                      {notificaciones.length}
                    </span>
                  </li>
                )}
                {EXISTE_MENU === "1" && (
                  <li className="dropdown-item-li" key={1}>
                    <button
                      className="dropdown-item p-2 d-flex justify-content-between align-items-center"
                      onClick={() => {
                        document.querySelector("#sideBarBtn").click();
                        ejecutar();
                      }}
                    >
                      Volver al menú <FontAwesomeIcon icon={faArrowsRotate} />
                    </button>
                  </li>
                )}
                <li className="dropdown-item-li" key={2}>
                  <button
                    className="dropdown-item p-2 d-flex justify-content-between align-items-center"
                    onClick={() => {
                      modalEjecutar(cerrarSession, "Se cerrará la sesión, ¿Desea continuar?", null);
                    }}
                  >
                    Cerrar sesión <FontAwesomeIcon style={{ fontWeight: "700" }} icon={faArrowRightFromBracket} />
                  </button>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

SideBar.propTypes = {
  ejecutar: PropTypes.func.isRequired,
};
